// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as fetchGetOrderPayByIdReducer } from './fetchGetOrderPayById';
import { reducer as fetchGetPaymentReducer } from './fetchGetPayment';
import { reducer as fetchWeChatScanPayReducer } from './fetchWeChatScanPay';
import { reducer as fetchGetAccessTokenReducer } from './fetchGetAccessToken';
import { reducer as fetchAliScanPayReducer } from './fetchAliScanPay';
import { reducer as fetchQueryOrderReducer } from './fetchQueryOrder';
import { reducer as fetchAddOrderFromCartsReducer } from './fetchAddOrderFromCarts';
import { reducer as fetchCcbScanPayReducer } from './fetchCcbScanPay';
import { reducer as fetchAggregatePayReducer } from './fetchAggregatePay';
import { reducer as fetchUpdateOrderStateReducer } from './fetchUpdateOrderState';
import { reducer as fetchGetPayTokenReducer } from './fetchGetPayToken';
import { reducer as fetchGetMaxCouponPriceReducer } from './fetchGetMaxCouponPrice';
import { reducer as fetchUseCouponReducer } from './fetchUseCoupon';

const reducers = [
  fetchGetOrderPayByIdReducer,
  fetchGetPaymentReducer,
  fetchWeChatScanPayReducer,
  fetchGetAccessTokenReducer,
  fetchAliScanPayReducer,
  fetchQueryOrderReducer,
  fetchAddOrderFromCartsReducer,
  fetchCcbScanPayReducer,
  fetchAggregatePayReducer,
  fetchUpdateOrderStateReducer,
  fetchGetPayTokenReducer,
  fetchGetMaxCouponPriceReducer,
  fetchUseCouponReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/pay/redux/reducer.js